import { Grid } from "@mui/material";

import { TextField } from "../../../components";

export default function FormTwo({ formikProps, editState }) {
  return (
    <Grid size={6}>
      <TextField
        size="small"
        label="Company Address"
        placeholder="Company Address"
        name="companyAddress"
        multiline
        disabled={!editState || formikProps.values.companyGSTNumber}
        formikProps={formikProps}
      />
    </Grid>
  );
}
